import { render, staticRenderFns } from "./dev-box1.vue?vue&type=template&id=bd6ba848&scoped=true&"
import script from "./dev-box1.vue?vue&type=script&lang=js&"
export * from "./dev-box1.vue?vue&type=script&lang=js&"
import style0 from "./dev-box1.vue?vue&type=style&index=0&id=bd6ba848&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6ba848",
  null
  
)

export default component.exports